/* 顶部导航：鼠标悬停即展开子菜单（2026-09-22）
 *
 * Dawn 的下拉菜单是 <details>/<summary>，原生只能点击展开。
 * 纯 CSS 打不开 <details>（UA 会隐藏非 summary 子节点，display 覆盖不可靠），
 * 所以用 JS 切换 open 属性。
 *
 * 几个必须处理的点：
 *  - 只在真有鼠标的设备上启用。触屏若也绑 hover，第一次点击会被 hover 抢走，
 *    变成要点两次。
 *  - 用事件委托而不是逐个绑定：主题编辑器会重渲染 header section，
 *    直接绑在元素上的监听会随之失效。
 *  - 移出时延迟再关，否则从 summary 移到子菜单的途中会闪一下就收起。
 *  - hover 展开后再点 summary 会把它切回关闭，所以 open 状态下拦掉默认行为。
 *  - 展开一个就关掉同级其它的，避免两个子菜单同时张着。
 *
 * 不改 details-disclosure.js：Dawn 的 HeaderMenu 监听 toggle 事件来维护
 * sticky header 的 preventHide 和 --header-bottom-position-desktop，
 * 我们通过设置 open 属性触发 toggle，那套逻辑照常生效。
 */
(() => {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const SEL = '.header__inline-menu details';
  const CLOSE_DELAY = 150;
  let timer;

  const setOpen = (d, on) => {
    if (d.open === on) return;
    d.open = on;
    const s = d.querySelector('summary');
    if (s) s.setAttribute('aria-expanded', String(on));
  };

  document.addEventListener('mouseover', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    const d = t.closest(SEL);
    if (!d) return;
    clearTimeout(timer);
    const menu = d.closest('.header__inline-menu');
    if (menu) {
      menu.querySelectorAll('details[open]').forEach((o) => {
        if (o !== d) setOpen(o, false);
      });
    }
    setOpen(d, true);
  });

  document.addEventListener('mouseout', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    const d = t.closest(SEL);
    if (!d) return;
    // 还在同一个 details 内部移动，不算离开
    if (e.relatedTarget instanceof Node && d.contains(e.relatedTarget)) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (d.matches(':hover')) return;
      setOpen(d, false);
    }, CLOSE_DELAY);
  });

  // hover 已经展开时，点击 summary 不要把它关掉
  document.addEventListener('click', (e) => {
    const t = e.target;
    if (!(t instanceof Element)) return;
    const s = t.closest(`${SEL} > summary`);
    if (s && s.parentElement && s.parentElement.open) e.preventDefault();
  });
})();
